import { styled } from "styled-components";
import { rgba, position } from "polished";
const AvatarDropzone = styled("div")`
  display: none;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  color: rgba(255, 255, 255, 0.65);
  line-height: 100vh;
  text-align: center;
`;
const AvatarUploaderText = styled("div")`
  margin-left: 16px;
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-weight: ${({ theme }) => theme.fontWeight.default};
  font-size: ${({ theme }) => theme.fontSize.default}px;
  line-height: ${({ theme }) => theme.lineHeight.default};
  color: rgba(0, 0, 0, 0.85);

  span {
    color: rgba(0, 0, 0, 0.45);
  }
`;
const AvatarUploaderWrapper = styled("div")({
  display: "flex",
  alignItems: "center"
});
const HiddenFileInputWrapper = styled("div")`
  display: none;
`;
const AvatarWithOverlay = styled("div")`
  position: relative;
  cursor: pointer;
`;
const Overlay = styled("button")(({ variant }) => ({
  alignItems: "center",
  border: "1px solid rgba(0, 0, 0, 0.15)",
  background: rgba(255, 255, 255, 0.95),
  borderRadius: variant === "organisation" ? 2 : "50%",
  color: rgba(0, 0, 0, 0.65),
  display: "flex",
  justifyContent: "center",
  ...position("absolute", 0),
  opacity: 0,
  width: "100%",
  zIndex: -1,
  "&:focus": {
    boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.05)",
    opacity: 1,
    zIndex: 2
  },
  "&:active": {
    background: "linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), rgba(255, 255, 255, 0.95);"
  },
  [`${AvatarWithOverlay}:hover > &&`]: {
    opacity: 1,
    zIndex: 2
  }
}));
export {
  AvatarDropzone,
  AvatarUploaderText,
  AvatarUploaderWrapper,
  AvatarWithOverlay,
  HiddenFileInputWrapper,
  Overlay
};
